// Algolia Analytics Tags Configuration: https://www.algolia.com/doc/guides/getting-insights-and-analytics/search-analytics/segmenting-your-analytics-data/#implementing-analytics-tags

export const getPlatformTags = (userAgent) => {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
    return "platform:mobile";
  }
  return "platform:desktop";
};

export const getURLTags = (pathname) => {
  /* eslint-disable */
  const [string, country, language, url] = pathname.match("^/([a-zA-Z]{2})/([a-zA-Z]{2})(/.*)?") ?? [];
  /* eslint-enable */
  const tags = [];
  if (country) {
    tags.push(`country:${country}`);
  }
  if (language) {
    tags.push(`language:${language}`);
  }
  if (url) {
    tags.push(`url:${url}`);
  }
  return tags;
};

export const getUserTags = function (cookies = null) {
  if (cookies === null) {
    return;
  }
  const [visitedCookie] = decodeURIComponent(cookies)
    .split(";")
    .filter((cookie) => cookie.indexOf("visited") >= 0);
  if (visitedCookie) {
    return "user:returning";
  }
  document.cookies = "visited=true";
  return "user:new";
};

export const buildTagsArray = (userAgent, cookies, pathname) =>
  [getPlatformTags(userAgent), getUserTags(cookies), ...getURLTags(pathname)].filter(
    (item) => typeof item !== "undefined"
  );
